import {
  Editable as ChakraEditable,
  EditableInputProps,
  EditablePreviewProps,
  type EditableRootProps,
} from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends EditableRootProps {
  previewProps?: EditablePreviewProps
  inputProps?: EditableInputProps
}

export default forwardRef<HTMLDivElement, Props>(({ previewProps, inputProps, ...rest }, ref) => {
  return (
    <ChakraEditable.Root ref={ref} {...rest}>
      <ChakraEditable.Preview {...previewProps} />
      <ChakraEditable.Input {...inputProps} />
    </ChakraEditable.Root>
  )
})
